import { createFileRoute } from '@tanstack/react-router'
import EmployeeGifts from '@/features/employee-portal/pages/EmployeeGifts'

export const Route = createFileRoute('/_authenticated/employee-portal/gifts')({
  component: EmployeeGifts,
})
